import { useIntl } from "react-intl";

import { Chip } from "@/components/Chip/Chip";
import { ExpandableSection } from "@/components/ExpandableSection/ExpandableSection";
import type { HotelData } from "@/features/hotels/types/types";

type Props = {
  hotel: HotelData;
};

export const HotelFacilities = ({ hotel }: Props) => {
  const intl = useIntl();

  const facilities = hotel.descriptions?.facilities?.split(",");

  if (!facilities) return null;

  return (
    <div className="section-card">
      <div className="mb-4 font-medium text-text-primary">
        {intl.formatMessage({
          defaultMessage: "Facilities",
          description: "Section heading for hotel facilities and amenities",
        })}
      </div>
      <ExpandableSection>
        <ul className="flex flex-wrap gap-2">
          {facilities.map((facility) => (
            <li key={facility}>
              <Chip
                label={facility}
                color="neutral-soft"
                size="medium"
                maxWidth="full"
              />
            </li>
          ))}
        </ul>
      </ExpandableSection>
    </div>
  );
};
